export const defaultControls = {
  selectionUp: [ 38 ],
  selectionDown: [ 40 ],
  select: [ 13 ],
  hideList: [ 27 ],
  showList: [ 40 ],
  autocomplete: [ 32, 13 ]
};

export const modes = {
  input: String,
  select: Object,
};

export function hasKeyCode(arr, event) {
  return hasKeyCodeByCode(arr, event.keyCode);
}

export function hasKeyCodeByCode(arr, keyCode) {
  if (arr.length <= 0) return false;

  const has = arr => arr.some(code => code === keyCode);
  if (Array.isArray(arr[0])) {
    return arr.some(array => has(array));
  } else {
    return has(arr);
  }
}

/** Возвращает 3 строки для автокомплита или пустой массив */
export function splitSuggestion(sugText, inputText) {
  inputText = inputText.trim();
  const start = sugText.toUpperCase().indexOf(inputText.toUpperCase());
  if (start == -1)
    return [];
  return [
    sugText.substring(0, start),
    sugText.substring(start, start + inputText.length),
    sugText.substring(start + inputText.length),
  ];
}

export function strhash(str) {
  var hash = 0;
  if (str.length == 0) {
    return hash;
  }
  for (var i = 0; i < str.length; i++) {
    var char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}